module.exports = __webpack_public_path__ + "media/recipes/119-04bdddf0.png";